import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../providers/AuthContext';

const DEPARTAMENTOS = [
  'Montevideo',
  'Artigas',
  'Canelones',
  'Cerro Largo',
  'Colonia',
  'Durazno',
  'Flores',
  'Florida',
  'Lavalleja',
  'Maldonado',
  'Paysandú',
  'Río Negro',
  'Rivera',
  'Rocha',
  'Salto',
  'San José',
  'Soriano',
  'Tacuarembó',
  'Treinta y Tres'
];

const BuyerForm = ({ onChange, shippingType, pickupLocation, errors = {} }) => {
  const { user, loading } = useContext(AuthContext);
  const [nombre, setNombre] = useState('');
  const [mail, setMail] = useState('');
  const [cedula, setCedula] = useState('');
  const [direccion, setDireccion] = useState('');
  const [ciudad, setCiudad] = useState('');
  const [departamento, setDepartamento] = useState('Montevideo');
  const [codigoPostal, setCodigoPostal] = useState('');
  const [telefono, setTelefono] = useState('');
  const [referencias, setReferencias] = useState('');
  const [marketingOptIn, setMarketingOptIn] = useState(false);
  
  const isPickup = shippingType === 'retiro_local';

  // Precargar datos cuando el usuario esté logueado
  useEffect(() => {
    if (user && !loading) {
      const googleName = user.displayName || '';
      const googleEmail = user.email || '';
      
      setNombre(googleName);
      setMail(googleEmail);
      
      // Notificar al componente padre con los datos precargados
      onChange({
        nombre: googleName,
        mail: googleEmail,
        cedula: '',
        direccion: '',
        ciudad: '',
        departamento: 'Montevideo',
        codigoPostal: '',
        telefono: '',
        referencias: '',
        marketingOptIn: false
      });
    }
  }, [user, loading]);

  // Enviar datos iniciales al componente padre cuando se monte el componente
  useEffect(() => {
    onChange({
      nombre,
      mail,
      cedula,
      direccion,
      ciudad,
      departamento,
      codigoPostal,
      telefono,
      referencias,
      marketingOptIn
    });
  }, []);

  // Función para validar los datos y pasar los valores al componente padre
  const handleInputChange = (field, value) => {
    // Actualizamos el estado local
    if (field === 'nombre') setNombre(value);
    if (field === 'mail') setMail(value);
    if (field === 'cedula') setCedula(value);
    if (field === 'direccion') setDireccion(value);
    if (field === 'ciudad') setCiudad(value);
    if (field === 'departamento') setDepartamento(value);
    if (field === 'codigoPostal') setCodigoPostal(value);
    if (field === 'telefono') setTelefono(value);
    if (field === 'referencias') setReferencias(value);
    if (field === 'marketingOptIn') setMarketingOptIn(value);

    // Informamos al componente padre con los valores actuales
    onChange({
      nombre: field === 'nombre' ? value : nombre,
      mail: field === 'mail' ? value : mail,
      cedula: field === 'cedula' ? value : cedula,
      direccion: field === 'direccion' ? value : direccion,
      ciudad: field === 'ciudad' ? value : ciudad,
      departamento: field === 'departamento' ? value : departamento,
      codigoPostal: field === 'codigoPostal' ? value : codigoPostal,
      telefono: field === 'telefono' ? value : telefono,
      referencias: field === 'referencias' ? value : referencias,
      marketingOptIn: field === 'marketingOptIn' ? value : marketingOptIn,
    });
  };

  return (
    <div className="mt-4">
      <h4>Datos del comprador</h4>
      {user && !loading && (
        <div className="alert alert-info mb-3">
          <i className="fas fa-info-circle me-2"></i>
          Datos precargados desde tu cuenta de Google. Puedes modificarlos si es necesario.
        </div>
      )}
      <div className="mb-3">
        <label>Nombre:</label>
        <input
          type="text"
          className={`form-control ${errors.nombre ? 'is-invalid' : ''}`}
          value={nombre}
          onChange={(e) => handleInputChange('nombre', e.target.value)}
          placeholder={!user ? "Ingresa tu nombre completo" : ""}
        />
      </div>
      <div className="mb-3">
        <label>Correo electrónico:</label>
        <input
          type="email"
          className={`form-control ${errors.mail ? 'is-invalid' : ''}`}
          value={mail}
          onChange={(e) => handleInputChange('mail', e.target.value)}
          placeholder={!user ? "ejemplo@correo.com" : ""}
        />
      </div>
      <div className="form-check mb-3">
        <input
          id="marketing-opt-in"
          type="checkbox"
          className="form-check-input"
          checked={marketingOptIn}
          onChange={(event) => handleInputChange('marketingOptIn', event.target.checked)}
        />
        <label className="form-check-label" htmlFor="marketing-opt-in">
          Quiero recibir novedades, lanzamientos y promociones por email. Puedo darme de baja cuando quiera.
        </label>
      </div>
      <div className="mb-3">
        <label>Cédula:</label>
        <input
          type="text"
          className={`form-control ${errors.cedula ? 'is-invalid' : ''}`}
          value={cedula}
          onChange={(e) => handleInputChange('cedula', e.target.value)}
          placeholder="Ingresa tu número de cédula"
        />
      </div>

      {isPickup ? (
        <>
          <div className="alert alert-success mb-3">
            <i className="fa-solid fa-store me-2"></i>
            <strong>{pickupLocation ? `Retiro en pickup ${pickupLocation.city}` : 'Retiro en pickup'}</strong>
            <p className="mb-0 mt-1">
              {pickupLocation
                ? `${pickupLocation.name}. Te enviaremos la dirección y los datos de contacto cuando el pedido esté pronto para retirar.`
                : 'Seleccioná arriba el punto de pickup donde querés retirar. Te contactaremos cuando esté listo.'}
            </p>
          </div>
          
          <div className="mb-3">
            <label>Teléfono de contacto: <span className="text-danger">*</span></label>
            <input
              type="tel"
              className={`form-control ${errors.telefono ? 'is-invalid' : ''}`}
              value={telefono}
              onChange={(e) => handleInputChange('telefono', e.target.value)}
              placeholder="Número de teléfono para avisarte cuando esté listo"
            />
          </div>
        </>
      ) : (
        <>
          <h5 className="mt-4 mb-3">
            <i className="fa-solid fa-location-dot me-2"></i>
            Dirección de envío
          </h5>
          
          <div className="mb-3">
            <label>Dirección completa: <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control ${errors.direccion ? 'is-invalid' : ''}`}
              value={direccion}
              onChange={(e) => handleInputChange('direccion', e.target.value)}
              placeholder="Calle, número, apartamento, etc."
            />
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Ciudad/Localidad: <span className="text-danger">*</span></label>
              <input
                type="text"
                className={`form-control ${errors.ciudad ? 'is-invalid' : ''}`}
                value={ciudad}
                onChange={(e) => handleInputChange('ciudad', e.target.value)}
                placeholder="Ciudad o localidad"
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>Departamento: <span className="text-danger">*</span></label>
              <select
                className="form-select"
                value={departamento}
                onChange={(e) => handleInputChange('departamento', e.target.value)}
              >
                {DEPARTAMENTOS.map(dep => (
                  <option key={dep} value={dep}>{dep}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Código postal:</label>
              <input
                type="text"
                className="form-control"
                value={codigoPostal}
                onChange={(e) => handleInputChange('codigoPostal', e.target.value)}
                placeholder="Código postal (opcional)"
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>Teléfono de contacto: <span className="text-danger">*</span></label>
              <input
                type="tel"
                className={`form-control ${errors.telefono ? 'is-invalid' : ''}`}
                value={telefono}
                onChange={(e) => handleInputChange('telefono', e.target.value)}
                placeholder="Número de teléfono"
              />
            </div>
          </div>

          <div className="mb-3">
            <label>Referencias de ubicación:</label>
            <input
              type="text"
              className="form-control"
              value={referencias}
              onChange={(e) => handleInputChange('referencias', e.target.value)}
              placeholder="Ej: Casa azul, frente a la plaza, etc. (opcional)"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default BuyerForm;
